export { default as Img200 } from './processed/200/Tulip-Fever.jpg';
export { default as Img400 } from './processed/400/Tulip-Fever.jpg';
export { default as Imgthumb } from './processed/thumb/Tulip-Fever.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Tulip-Fever.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Tulip-Fever.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      188,
      90,
      28
    ],
    "_population": 4,
    "_hsl": [
      0.06458333333333334,
      0.7407407407407406,
      0.42352941176470593
    ]
  },
  "LightVibrant": {
    "_rgb": [
      219,
      199,
      173
    ],
    "_population": 2386,
    "_hsl": [
      0.09420289855072465,
      0.3898305084745762,
      0.7686274509803921
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      117,
      48,
      12
    ],
    "_population": 36,
    "_hsl": [
      0.05714285714285714,
      0.813953488372093,
      0.2529411764705882
    ]
  },
  "Muted": {
    "_rgb": [
      162,
      136,
      99
    ],
    "_population": 1018,
    "_hsl": [
      0.09788359788359789,
      0.253012048192771,
      0.5117647058823529
    ]
  },
  "LightMuted": {
    "_rgb": [
      205,
      180,
      158
    ],
    "_population": 74,
    "_hsl": [
      0.07801418439716314,
      0.3197278911564626,
      0.711764705882353
    ]
  },
  "DarkMuted": {
    "_rgb": [
      68,
      53,
      36
    ],
    "_population": 1301,
    "_hsl": [
      0.08854166666666669,
      0.3076923076923077,
      0.20392156862745098
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Tulip-Fever.js